<template>
    <div v-if="reminders">
        <h1 class="title is-3 between-center">
            <span>
                <span>Reminders</span>
                <a href="#" @click.prevent="isTableSettingsModalActive = true" class="gear">
                    <o-icon pack="fa" icon="gear" size="is-small" />
                </a>
            </span>
            <div class="field is-grouped">
                <p v-if="isDeleteSelectedButtonVisible" class="control">
                    <a @click.prevent="snoozedRemindersChecked" class="button is-warning"><span>Snooze
                            selected</span></a>
                </p>
                <p v-if="isDeleteSelectedButtonVisible" class="control">
                    <a @click.prevent="confirmCustomDelete" class="button is-danger"><span>Delete selected</span></a>
                </p>
            </div>

        </h1>
        <div class="columns">
            <div class="column">
                <o-tabs type="is-boxed" @update:modelValue="checkedRows = []">
                    <o-tab-item label="All">
                        <o-table v-if="isTableVisible" :data="reminders" :bordered="table.bordered"
                            :striped="table.striped" :narrowed="table.narrowed" :checkable="table.checkable"
                            :mobile-cards="table.mobileCards" :paginated="table.paginated"
                            :pagination-simple="table.paginationSimple" :per-page="table.perPage"
                            :default-sort="['remind_at', 'desc']" v-model:selected="selected"
                            :checked-rows="checkedRows" @update:checkedRows="$event => checkedRows = $event">
                            <o-table-column v-for="col in tableColumns" v-bind="col" #default="{ row }"
                                :field="col.field" :label="col.field === 'actions' ? '' : col.label"
                                :sortable="col.sortable">
                                <span v-if="col.field === 'description'">
                                    {{ $filters.valueOrDefault(row[col.field]) }}
                                </span>
                                <span v-if="col.field === 'project'">
                                    <router-link v-if="row.reference_type === 'email'"
                                        :to="{ name: 'emails.view', params: { message_id: row.message.thread_id, selected_id: row.message.message_id } }">
                                        {{ row.message.subject }}
                                    </router-link>
                                    <div v-if="checkIfprojectIdExists(row)">
                                        <router-link
                                            :to="{ name: 'projects.show', params: { slug: itemReferenceProject(row) } }">
                                            {{ row.reference_type != 'project' ? itemReferenceProjectName(row) :
                                            projectNameById(row.project_id) }}
                                        </router-link>
                                    </div>
                                    <div v-if="!checkIfprojectIdExists(row)">
                                        this proposal haven't converted
                                    </div>
                                </span>
                                <span v-if="col.field === 'reference_type'">
                                    {{ row[col.field] }}
                                    <router-link :to="itemReferenceLink(row)">
                                        {{ itemReferenceName(row) }}
                                    </router-link>
                                </span>
                                <span v-if="col.field === 'snoozed'">
                                    {{ reminderTypeById(row.id) }}
                                </span>
                                <router-link v-if="col.field === 'user_id'"
                                    :to="{ name: 'users.show', params: { slug: row.user_id } }">
                                    {{ $filters.valueOrDefault(userNameById(row.user_id)) }}
                                </router-link>
                                <span v-if="col.field === 'remind_at'">
                                    {{ $filters.datetime(row[col.field]) }}
                                </span>
                                <span v-if="col.field === 'actions'">
                                    <button class="button is-small is-warning mx-1"
                                        @click="openReminderModal(row)">Snooze</button>
                                    <button class="button is-small is-danger mx-1"
                                        @click="confirmCustomDelete(row)">Remove</button>
                                </span>
                            </o-table-column>

                            <template #empty>
                                <div class="has-text-centered">
                                    This table is empty!
                                </div>
                            </template>
                        </o-table>
                    </o-tab-item>
                    <o-tab-item label="Active">
                        <o-table v-if="isTableVisible" :data="activeReminders" :bordered="table.bordered"
                            :striped="table.striped" :narrowed="table.narrowed" :checkable="table.checkable"
                            :mobile-cards="table.mobileCards" :paginated="table.paginated"
                            :pagination-simple="table.paginationSimple" :per-page="table.perPage"
                            :default-sort="['remind_at', 'desc']" v-model:selected="selected"
                            :checked-rows="checkedRows" @update:checkedRows="$event => checkedRows = $event">
                            <o-table-column v-for="col in tableColumns" v-bind="col" #default="{ row }"
                                :field="col.field" :label="col.field === 'actions' ? '' : col.label"
                                :sortable="col.sortable">
                                <span v-if="col.field === 'description'">
                                    {{ $filters.valueOrDefault(row[col.field]) }}
                                </span>
                                <span v-if="col.field === 'reference_type'">
                                    {{ row[col.field] }}
                                    <router-link :to="itemReferenceLink(row)">
                                        {{ itemReferenceName(row) }}
                                    </router-link>
                                </span>
                                <span v-if="col.field === 'snoozed'">
                                    {{ reminderTypeById(row.id) }}
                                </span>
                                <router-link v-if="col.field === 'user_id'"
                                    :to="{ name: 'users.show', params: { slug: row.user_id } }">
                                    {{ $filters.valueOrDefault(userNameById(row.user_id)) }}
                                </router-link>
                                <span v-if="col.field === 'remind_at'">
                                    {{ $filters.datetime(row[col.field]) }}
                                </span>
                                <span v-if="col.field === 'actions'">
                                    <button class="button is-small is-warning mx-1"
                                        @click="openReminderModal(row)">Snooze</button>
                                    <button class="button is-small is-danger mx-1"
                                        @click="confirmCustomDelete(row)">Remove</button>
                                </span>
                            </o-table-column>

                            <template #empty>
                                <div class="has-text-centered">
                                    This table is empty!
                                </div>
                            </template>
                        </o-table>
                    </o-tab-item>
                    <o-tab-item label="Snoozed">
                        <o-table v-if="isTableVisible" :data="snoozedReminders" :bordered="table.bordered"
                            :striped="table.striped" :narrowed="table.narrowed" :checkable="table.checkable"
                            :mobile-cards="table.mobileCards" :paginated="table.paginated"
                            :pagination-simple="table.paginationSimple" :per-page="table.perPage"
                            :default-sort="['remind_at', 'desc']" v-model:selected="selected"
                            :checked-rows="checkedRows" @update:checkedRows="$event => checkedRows = $event">
                            <o-table-column v-for="col in tableColumns" v-bind="col" #default="{ row }"
                                :field="col.field" :label="col.field === 'actions' ? '' : col.label"
                                :sortable="col.sortable">
                                <span v-if="col.field === 'description'">
                                    {{ $filters.valueOrDefault(row[col.field]) }}
                                </span>
                                <span v-if="col.field === 'reference_type'">
                                    {{ row[col.field] }}
                                    <router-link :to="itemReferenceLink(row)">
                                        {{ itemReferenceName(row) }}
                                    </router-link>
                                </span>
                                <span v-if="col.field === 'snoozed'">
                                    {{ reminderTypeById(row.id) }}
                                </span>
                                <router-link v-if="col.field === 'user_id'"
                                    :to="{ name: 'users.show', params: { slug: row.user_id } }">
                                    {{ $filters.valueOrDefault(userNameById(row.user_id)) }}
                                </router-link>
                                <span v-if="col.field === 'remind_at'">
                                    {{ $filters.datetime(row[col.field]) }}
                                </span>
                                <span v-if="col.field === 'actions'">
                                    <!--                                          <button class="button is-small is-warning mx-1" @click="openReminderModal(row)">Snooze</button>-->
                                    <button class="button is-small is-danger mx-1"
                                        @click="confirmCustomDelete(row)">Remove</button>
                                </span>
                            </o-table-column>
                            <template #empty>
                                <div class="has-text-centered">
                                    This table is empty!
                                </div>
                            </template>
                        </o-table>

                    </o-tab-item>
                </o-tabs>
            </div>
        </div>
        <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isReminderModalActive"
            has-modal-card>
            <reminder-modal :reminder-id="currentReminder.id" :reminder-snoozed="snoozedChecked" />
        </o-modal>

        <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive"
            has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName" />
        </o-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
    checkIfprojectIdExists,
    itemReferenceProject,
    itemReferenceProjectName
} from "../../store/getters/references";
import Table from './../../mixins/Table';

export default {
    mixins: [Table],

    data() {
        return {
            isViewReminderModalActive: false,
            isReminderModalActive: false,
            tableName: 'reminders-index',
            currentReminder: {},
            snoozedChecked: [],
            date: null
        }
    },

    computed: {
        ...mapGetters([
            'reminders', 'activeReminders', 'snoozedReminders', 'itemReferenceName',
            'itemReferenceLink', 'reminderTypeById', 'currentUserId', 'userNameById', 'projectNameById', 'itemReferenceProject', 'checkIfprojectIdExists', 'itemReferenceProjectName'
        ])
    },

    mounted() {
        // this.fetchReminders({ user_id: this.currentUserId })
    },

    methods: {
        itemReferenceProjectName,
        checkIfprojectIdExists,
        itemReferenceProject,
        ...mapActions(['fetchReminders']),

        ...mapActions({
            removeItem: 'removeReminder'
        }),

        handleRemove(item) {
            this.removeItem(item)
                .then(res => {
                    this.successMessage('Reminder has been removed')
                    return res
                })
        },

        openReminderModal(reminder) {
            this.currentReminder = reminder
            this.isReminderModalActive = true
        },

        snoozedRemindersChecked() {
            this.checkedRows.map((item) => {
                this.snoozedChecked.push(item)
            })
            this.isReminderModalActive = true
        }
    }
}
</script>